// extracted by mini-css-extract-plugin
export default {"subtitle":"PlaceListModal_subtitle__c9TAO","modalContent":"PlaceListModal_modalContent__YEqJ+"};